const medicalProcedureInformationSchema = {
  procedureName: {
    displayName: 'Nome do procedimento',
    type: 'string',
    notAvailable: 'Não informado',
  },
  description: {
    displayName: 'Descrição SIGTAP',
    type: 'string',
    notAvailable: 'Não informado',
  },
  isEvaluated: {
    displayName: 'Avaliado',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  examResult: {
    displayName: 'Resultado do exame',
    type: 'string',
    notAvailable: 'Não informado',
  },
  examResultDate: {
    displayName: 'Data do resultado',
    type: 'date',
    notAvailable: 'Não informado',
    mask: 'date'
  },
  examRequestDate: {
    displayName: 'Data de solicitação',
    type: 'date',
    notAvailable: 'Não informado',
    mask: 'date'
  },
  examPerformedDate: {
    displayName: 'Data de realização',
    type: 'date',
    notAvailable: 'Não informado',
    mask: 'date'
  },
  observation: {
    displayName: 'Observação',
    type: 'string',
    notAvailable: 'Não informado',
  },
  attendanceDateTime: {
    displayName: 'Data e hora do atendimento',
    type: 'datetime',
    notAvailable: 'Não informado',
    mask: 'date'
  },
  professionalName: {
    displayName: 'Nome do profissional de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  healthUnitName: {
    displayName: 'Nome da unidade de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  teamName: {
    displayName: 'Nome da equipe de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  weight: {
    displayName: 'Peso',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'weightKg',
  },
  height: {
    displayName: 'Altura',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'heightMeter',
  },
  typeOfAttendance: {
    displayName: 'Tipo de atendimento',
    type: 'string',
    notAvailable: 'Não informado',
  },
  isVaccinationUpToDate: {
    displayName: 'Vacinação em dia',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
}

export default medicalProcedureInformationSchema
